/* src/app/modules/employees/employees-dialog-delete.component.css */
.ed-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 20px 20px 0;
  position: relative;
}
.ed-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(220, 38, 38, 0.1);
  flex-shrink: 0;
}
.ed-icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #dc2626;
}
.ed-title {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #1a1d23;
  line-height: 1.3 !important;
}
.ed-sub {
  margin: 3px 0 0;
  font-size: 12px;
  color: #6b7280;
}
.ed-close {
  position: absolute !important;
  top: 12px;
  right: 12px;
  color: #9ca3af !important;
}
.ed-content {
  padding: 16px 20px !important;
}
.ed-msg {
  margin: 0;
  font-size: 14px;
  color: #374151;
}
.ed-feedback {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 8px;
  background: rgba(22, 163, 74, 0.08);
  color: #166534;
  font-size: 13px;
  font-weight: 500;
}
.ed-feedback mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.ed-actions {
  padding: 8px 20px 20px !important;
  justify-content: flex-end !important;
  gap: 8px;
}
.ed-btn-delete {
  background-color: #dc2626 !important;
  color: #fff !important;
  font-weight: 500 !important;
}
/*# sourceMappingURL=employees-dialog-delete.component.css.map */
